import http from '../http'

const api = {
    // 获取导航
    getNavs(params) {
        return http.get('/wp-json/dt_api/navbar', {
            params,
        })
    },
    // 获取通用配置
    getCommonConfig(params) {
        return http.get('/wp-json/dt_api/common_config', {
            params,
        })
    }
}

const state = {
    navs: [],
    footer: {
        footer_nav: [],
        footer_text: {},
    },
    logo: '',
    logo_dark: '',
    logo_light: '',
    theme: 'dark',
    pageTheme: 'dark',
    site_title: '',
    wxShare: {},
    wechat_share_default_image: '',
    wechat_share_default_description: '',
    hide_en_cn_switch: false,
}

const mutations = {
    GET_NAVS: state => {
        return state
    },
    SET_NAVS: (state, {navs}) => {
        state.navs = navs
    },
    GET_COMMON_CONFIG: state => {
        return state
    },
    SET_COMMON_CONFIG: (state, {navs, footer, logo_dark, logo_light, site_title, wechat_share_default_image, wechat_share_default_description, hide_en_cn_switch}) => {
        state.navs = navs
        state.footer = footer
        state.logo = logo_dark
        state.logo_dark = logo_dark
        state.logo_light = logo_light
        state.site_title = site_title
        state.wechat_share_default_image = wechat_share_default_image
        state.wechat_share_default_description = wechat_share_default_description
        state.hide_en_cn_switch = hide_en_cn_switch

        document.title = site_title
    },
    SET_THEME: (state, {theme, wxShare}) => {
        state.theme = theme || 'dark'
        state.wxShare = wxShare || {}
    },
    SET_PAGE_THEME: (state, {theme}) => {
        state.pageTheme = theme || 'dark'
    }
}

// 所有的mutations转换成actions进行调用
const actions = {
    async getNavs({commit}) {
        commit('GET_NAVS')
        const lang = window.localStorage.getItem('lang')

        await api.getNavs({
            lang,
        }).then(res => {
            if (res.data.data) {
                commit('SET_NAVS', {
                    navs: res.data.data
                })
            }
        })
    },
    async getCommonConfig({commit}) {
        commit('GET_COMMON_CONFIG')
        const lang = window.localStorage.getItem('lang')

        await api.getCommonConfig({
            lang,
        }).then(res => {
            if (res.data.data) {
                commit('SET_COMMON_CONFIG', {
                    navs: res.data.data.navbar,
                    footer: res.data.data.footer,
                    logo: res.data.data.logo,
                    logo_dark: res.data.data.logo_dark,
                    logo_light: res.data.data.logo_light,
                    site_title: res.data.data.site_title,
                    wechat_share_default_image: res.data.data.wechat_share_default_image,
                    wechat_share_default_description: res.data.data.wechat_share_default_description,
                    hide_en_cn_switch: res.data.data.hide_en_cn_switch,
                })
            }
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
